import React from 'react';
import axios from 'axios';
import moment from 'moment';
import {Form, Header, Input, Loader, Segment} from 'semantic-ui-react';
import { fetchMarks } from '../../Lookups/util';
import Students from './Students';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const types = [
    { key: 1, value: 1, text: 'Svi studenti' },
    { key: 2, value: 2, text: 'Studenti po grupama' }
];

export default class ExamApplicationsCurrentYear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            marks: [],
            students: [],
            courses: [],
            course: '',
            exams: [],
            exam: '',
            type: '',
            group: '',
            gradedActivityId: '',
            selectedData: [],
            passedStudents: [],
            language: 'ba',
            languages: [
                {
                    text: 'B/H/S',
                    key: 'ba',
                    value: 'ba'
                },
                {
                    text: 'Engleski',
                    key: 'en',
                    value: 'en'
                },
            ],
            orientation: 'horizontal',
            orientations: [
                {
                    text: 'Horizontalno',
                    key: 'horizontal',
                    value: 'horizontal'
                },
                {
                    text: 'Vertikalno',
                    key: 'vertical',
                    value: 'vertical'
                }
            ],

            showGroups: false,
            loadedCourses: false,
            openStudents: false,

        };

        this.getStudents = this.getStudents.bind(this);
        this.onDataChange = this.onDataChange.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.selectFilter = this.selectFilter.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    componentDidMount() {
        axios.all([fetchMarks()])
            .then(axios.spread((marksRes) => {
                this.setState({
                    marks: marksRes.data,
                });
            }))
            .then(re => {
                this.getStudents();
            })
            .catch(err => {
                console.log('Failed to fetch current academic year or marks');
            });
    }


    getStudents() {
        const { marks } = this.state;
        let obj = { };
        this.setState({loader: true });
        axios({
            method: 'post',
            url: `/exams/students/${parseInt(localStorage.getItem('gradedActivityId'))}`,
            data: { ...obj }
        })
            .then(res => {
                const students = res.data.sort((a, b) => a.inputDate - b.inputDate).map(el => ({
                    ...el,
                    examDate: el.date ? moment(el.date).format('D. M. YYYY.') : '',
                    inputDate: el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : '',
                    grade: marks.find(ell => ell.id === el.markId).displayName,
                    id: el.studentGradedActivityId
                }));
                this.setState({ students, openStudents: true, loader: false });
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    onDataChange(row) {
        const pos = this.state.selectedData.findIndex(el => el.id === row.id);
        if (pos === -1) {
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            const newSelectedData = this.state.selectedData.filter(el => el.id !== row.id);
            this.setState({ selectedData: newSelectedData });
        }
    }

    selectAll() {
        const { students, selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === students.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: students });
        }
    }

    selectFilter() {
        const { students, selectedData } = this.state;

        let passedStudents = [];
        students.map(el =>
            (this.state.marks.find(e => e.id === el.markId).passed === true ?
                passedStudents.push(el)
                : null));

        this.setState({ passedStudents });

        if (selectedData.length === passedStudents.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: passedStudents });
        }
    }

    render() {
        const {
            language, languages, orientation, orientations
        } = this.state;

        return (
            <div>
                {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.openStudents &&
                    <div>
                        <h1>Prijave za ispite</h1>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                    <Header.Content>
                                        {localStorage.getItem('courseImplementationName')} / {localStorage.getItem('gradedActivityName')} / {moment(parseInt(localStorage.getItem('gradedActivityDate'))).format('D. M. YYYY.')}
                                    </Header.Content>
                                    <Header.Subheader floated="left">
                                        {(localStorage.getItem('courseComment'))==='null' ? 'Naziv predmeta / tip ispita / datum' : localStorage.getItem('courseComment')}
                                    </Header.Subheader>
                                    {/*<Header.Subheader>Naziv predmeta / tip ispita / datum</Header.Subheader>*/}
                                </Header>
                            </Segment>

                            {/*a*/}
                            <Segment>
                                <Form noValidate>
                                    <Form.Group widths="equal">
                                        <Form.Field required>
                                            <label>Jezik</label>
                                            <Form.Dropdown
                                                selection
                                                placeholder="Odaberite jezik"
                                                value={language}
                                                onChange={this.handleInputChange}
                                                name="language"
                                                options={languages}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <label>Orijentacija</label>
                                            <Form.Dropdown
                                                selection
                                                placeholder="Odaberite orijentaciju"
                                                value={orientation}
                                                onChange={this.handleInputChange}
                                                name="orientation"
                                                options={orientations}
                                                fluid
                                            />
                                        </Form.Field>
                                        <Form.Field />
                                    </Form.Group>
                                </Form>
                            </Segment>
                            {/*a*/}
                            <Segment>
                                <Students
                                    students={this.state.students}
                                    selectedData={this.state.selectedData}
                                    onDataChange={this.onDataChange}
                                    selectAll={this.selectAll}
                                    selectFilter={this.selectFilter}
                                    passedStudents={this.state.passedStudents}
                                    chosenLanguage={this.state.language}
                                    chosenOrientation={this.state.orientation}
                                />
                            </Segment>
                        </Segment.Group>
                    </div>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamApplications/ExamApplicationsForCurrentExam.js